import * as React from 'react';
import KickImage from 'Reuseables/KickImage';
import { TCategoryListDetailProps } from './definitions';
import Styles from './CategoryListDetail.module.scss';
import MenuRow from '../../Molecules/MenuRow';
import { SidebarMenuContext } from 'Pages/Home/Context/SidebarMenuContext';
import { useGetMenuData } from 'components/PageApp/SidebarMenu/Hooks/useGetMenuData';
import { useHistory } from 'react-router';
import { joinClassnames } from 'helpers/classNames';

export default function CategoryListDetail({
  dataAuth,
}: TCategoryListDetailProps) {
  const history = useHistory();

  const {
    setMenuDetailCategory,
    menuDetailCategory,
    toggleMenuDetail,
    toggleMenuShow,
  } = React.useContext(SidebarMenuContext);

  const listData = useGetMenuData(menuDetailCategory);

  const getTitleText = () => {
    switch (menuDetailCategory) {
      case 'sneakers':
        return 'SNEAKERS';
      case 'apparels':
        return 'APPAREL';
      case 'handbags':
        return 'LUXURY';
      case 'lifestyles':
        return 'ELECTRONICS & COLLECTIBLES';
      default:
        return '';
    }
  };

  const onClickBack = () => {
    toggleMenuDetail(false);
    setMenuDetailCategory('');
  };

  const onClickItem = (url: string) => {
    toggleMenuShow(false);
    history.push(url);
  };

  const listHeight = React.useMemo(
    () => (listData.length + 1) * 63.5 + 220,
    [listData],
  );

  return (
    <div
      className={joinClassnames(
        Styles['category-list-detail-wrapper'],
        listHeight < document.body.clientHeight ? Styles['full-height'] : '',
      )}
    >
      <MenuRow type="logo" />
      <MenuRow type="title" text={getTitleText()} onClick={onClickBack} />
      {listData.map((item) => (
        <MenuRow
          type="item"
          text={item.title}
          onClick={() => onClickItem(item.url)}
        />
      ))}
    </div>
  );
}
